<template>
    <MainContent>
        <template #title>
            Dashboard
        </template>
        <template #subtitle>
            Wanon Niwat Hospital [WEBPORTAL WNH]
        </template>
        <template #breadcrumb>
            Dashboard
        </template>
        <template #header>
            <Overlay :showOverlay="!items.length" />

            <div class="tile-title-w-btn">
                <h3 class="title">All Items</h3>
                <p>
                    <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                        <i class="bi bi-plus-square me-2"></i>Add Item
                    </a>
                </p>
            </div>
        </template>
        <template #content>
            <div class="tile-body">
                <!-- {{ date }} -->
                {{ date }}
                <VueDatePicker model-type="yyyy-mm-dd" :model-value="date" @update:model-value="setDate"
                    :format="formatDate" :format-locale="th" :enable-time-picker="false" auto-apply />

                <VueDatePicker :model-value="dateTime" @update:model-value="setDateTime"
                    :format="formatDateTime" :format-locale="th" auto-apply />

                    <VueDatePicker 
                    model-type="HH:mm" 
                    :model-value="time" 
                    @update:model-value="setTime"
                    time-picker
                    :format-locale="th"
                    :time-only="true"
                    auto-apply
                />

                <!-- Modal for Add/Edit Item -->
                <div class="modal fade" id="itemModal" tabindex="-1" aria-labelledby="itemModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{{ modalMode === 'edit' ? 'Edit Item' : 'Add Item' }}</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <form @submit.prevent="handleSubmit(editingItem)">
                                <div class="modal-body">
                                    <div class="mb-3">
                                        <label for="name" class="form-label">Name</label>
                                        <input type="text" id="name" class="form-control" v-model="editingItem.name"
                                            required />
                                    </div>
                                    <div class="mb-3">
                                        <label for="email" class="form-label">Email</label>
                                        <input type="email" id="email" class="form-control" v-model="editingItem.email"
                                            required />
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" @click="hideModal">Close</button>
                                    <button type="submit" class="btn btn-primary">Save changes</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script setup>
import { Modal } from 'bootstrap';
import { ref } from 'vue';
import MainContent from '@/components/MainContent.vue';
import Overlay from '../components/Overlay.vue';
import { th } from 'date-fns/locale';
import moment from 'moment';
moment.locale('th')

const date = ref(moment().format('YYYY-MM-DD'));

const formatDate = (date) => {
    return moment(date).format('DD MMM YYYY');
}

const setDate = (value) => {
    date.value = value;
}

const time = ref(moment().format('HH:mm'));

const setTime = (value) => {
    // Update the time value using Moment.js to format it as HH:mm
    time.value = moment(value, 'HH:mm').format('HH:mm');
};

const dateTime = ref(moment().format('YYYY-MM-DD HH:mm:ss'));

const formatDateTime = (date) => {
    return moment(date).format('วันที่: YYYY-MM-DD เวลา: HH:mm:ss');
}

const setDateTime = (value) => {
    dateTime.value = moment(value).format('YYYY-MM-DD HH:mm:ss');
}


const items = ref([
    { id: 1, name: 'John Doe', email: 'john@example.com' },
    { id: 2, name: 'Jane Smith', email: 'jane@example.com' }
]);

const editingItem = ref({ id: null, name: '', email: '' });
const modalMode = ref('add');

const openAddModal = () => {
    editingItem.value = { id: null, name: '', email: '' };
    modalMode.value = 'add';
    new Modal(document.getElementById('itemModal')).show();
};

const hideModal = () => {
    const modalElement = document.getElementById('itemModal');
    const modal = Modal.getInstance(modalElement);
    if (modal) modal.hide();
};

// const handleEditItem = (item) => {
//     editingItem.value = { ...item };
//     modalMode.value = 'edit';
//     new Modal(document.getElementById('itemModal')).show();
// };

// const handleDeleteItem = (id) => {
//     items.value = items.value.filter(item => item.id !== id);
// };

const handleSubmit = (updatedItem) => {
    if (modalMode.value === 'edit') {
        const index = items.value.findIndex(item => item.id === updatedItem.id);
        if (index !== -1) {
            items.value[index] = { ...updatedItem };
        }
    } else {
        items.value.push({ ...updatedItem, id: Date.now() });
    }
    hideModal();
};


</script>

<style scoped>
/* Add your styles here */
</style>
